import o from "./index.es172.js";
import * as m from "./index.es173.js";
const t = {
  ...m,
  ...o
};
export {
  t as default
};
//# sourceMappingURL=index.es145.js.map
